// extracted by mini-css-extract-plugin
export var cardHeader = "_ik-1";
export var contentCard = "_ik-0";
export var headerActions = "_ik-3";
export var reorderHandle = "_ik-5";
export var titleArea = "_ik-2";
export var titleAreaWithHandle = "_ik-4";